/* eslint-disable react/prop-types */
import { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import './TabNav.scss';

export default function TabNav({ children, activeIndex, buttonWidth }) {
  const [enableScroll, setEnableScroll] = useState(false);
  const [targetScroll, setTargetScroll] = useState(0);

  const navElement = useRef();
  const tabParentElement = useRef();

  const defaultButtonWidth = 142;

  const selectedButtonWidth = buttonWidth ?? defaultButtonWidth;
  const requiredWidth = children.length * selectedButtonWidth;
  const indicatorStyle = {
    width: `${selectedButtonWidth}px`,
    left: `${selectedButtonWidth * activeIndex + targetScroll}px`,
  };

  const contentStyle = {
    left: `${targetScroll}px`,
  };

  useEffect(() => {
    const handleResize = () => {
      if (navElement.current.getBoundingClientRect().width < requiredWidth) {
        setEnableScroll(true);
      } else {
        setEnableScroll(false);
        setTargetScroll(0);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const scrollRight = () => {
    const rect = tabParentElement.current.getBoundingClientRect();
    if (rect.width >= requiredWidth) {
      return;
    }

    const allowedScroll = requiredWidth - rect.width;
    const currentScroll = -targetScroll;

    let newScroll = currentScroll + rect.width;
    if (newScroll > allowedScroll) newScroll = allowedScroll;
    setTargetScroll(-newScroll);
  };

  const scrollLeft = () => {
    const rect = tabParentElement.current.getBoundingClientRect();
    if (rect.width >= requiredWidth) {
      return;
    }

    const currentScroll = -targetScroll;

    let newScroll = currentScroll - rect.width;
    if (newScroll < 0) newScroll = 0;
    setTargetScroll(-newScroll);
  };

  return (
    <div className="tab-nav-wrapper" ref={navElement}>
      {enableScroll && (
        <button className="scroll-button" type="button" onClick={scrollLeft}>
          <FontAwesomeIcon className="scroll-arrow" icon={faChevronLeft} />
        </button>
      )}
      <div className="tab-nav-content" ref={tabParentElement}>
        <div style={contentStyle} className="tab-nav-scroll-content">
          {children}
        </div>
        <div style={indicatorStyle} className="selected-indicator" />
      </div>
      {enableScroll && (
        <button className="scroll-button" type="button" onClick={scrollRight}>
          <FontAwesomeIcon className="scroll-arrow" icon={faChevronRight} />
        </button>
      )}
    </div>
  );
}

TabNav.Tab = function Tab({ title, onClick, active, disabled, width }) {
  return (
    <button
      className={`${active ? 'active-tab' : ''}`}
      type="button"
      onClick={onClick}
      disabled={disabled}
      style={{ width: `${width ?? 142}px` }}
    >
      <p>{title}</p>
    </button>
  );
};
